import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import StalkerStore from '../../../store/StalkerStore';
import configs from '../../../configs';

// The backend owns the OAuth flow: /api/myob redirects to MYOB, and its callback returns the user to
// /arliveapp?signup=... to choose the company file and finish the registration.
const StepConnectMyob = () => {
  const handleConnect = () => {
    try {
      StalkerStore.track('Registration - Connect to MYOB', {});
    } catch (e) {
      // Analytics can be blocked by the browser; never let it stop the redirect.
    }
    window.location.assign(configs.myob_auth);
  };

  return (
    <Grid container spacing={2} style={{ padding: '24px' }}>
      <Grid item xs={12} className="ez-text-center">
        <Typography variant="body1" gutterBottom>
          To get started, sign in to MYOB and allow ezyCollect to access your AccountRight Live company file.
        </Typography>
        <Typography variant="body2" color="textSecondary">
          You will come back here to choose the company file and finish your registration.
        </Typography>
      </Grid>
      <Grid item xs={12} className="ez-text-center">
        <Button variant="contained" color="primary" size="large" onClick={handleConnect}>
          Connect to MYOB
        </Button>
      </Grid>
    </Grid>
  );
};

export default StepConnectMyob;
